import { AuthState } from '@okta/okta-auth-js'
import { ZollApiResponse } from '../../zollApi/store/zollApi.types'
import { UserTypeConstants } from './userType.constants'

export interface ILoginState {
  loginFailed: boolean
  authenticationJwt: string | null
  loginPhaseIsLoading: boolean
  userVerifyErrorText: string
  loginCallbackUrl: string
}

export interface ILoginLogo {
  src: string
  altText: string
}

export interface ILoginAction extends ILoginState {
  type: string
}

export interface AuthPrivilege {
  name: string
  id: number
}

export interface AuthenticationResponse extends ZollApiResponse {
  data: {
    authState: AuthState
    user: {
      userId: number
      privileges: AuthPrivilege[]
    }
  }
}

export interface IDeviceDetails {
  deviceId: string
  deviceType: string
  deviceName: string
  userAgent: string
  sourceType: string
  screen: string
  created: string
}

export interface AuthenticationRequest {
  serviceId: number
  username: string
  password: string
  accessToken?: string
  deviceDetails?: IDeviceDetails
}

export interface APIError {
  message: string
  stackTrace: string
  cause: APIError
}

export interface GetUserTypeResponse extends ZollApiResponse {
  data: GetUserTypeData
}

export interface GetUserTypeData {
  userType: string
  ssoBaseUrl: string
  ssoClientId: string
  ssoAuthorizationServer: string
}

export const SSOUserType: GetUserTypeData = {
  userType: UserTypeConstants.USER_TYPE_SSO,
  ssoBaseUrl: '',
  ssoClientId: '',
  ssoAuthorizationServer: '',
}

export interface FederatedClaims {
  aud?: string
  auth_time?: number
  iss?: string
  sub: string
  logout_url?: string
}

export interface IBeforeInstallPromptEvent extends Event {
  readonly platforms: string[]
  readonly userChoice: Promise<{
    outcome: 'accepted' | 'dismissed'
    platform: string
  }>
  prompt(): Promise<void>
}

declare global {
  interface WindowEventMap {
    beforeinstallprompt: IBeforeInstallPromptEvent
  }
}

export type HandleBeforeInstallPromptListener = (event: IBeforeInstallPromptEvent) => void
